"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnMxUsd = exports.EnMxMxn = exports.EnMxMxp = exports.EsMxUsd = exports.EsMxMxn = exports.EsMxMxp = void 0;
class EsMxMxp {
    constructor() {
        this.locale = "es-mx";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "MXP",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "-Cn",
        };
    }
}
exports.EsMxMxp = EsMxMxp;
class EsMxMxn {
    constructor() {
        this.locale = "es-mx";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "MXN",
            symbol: "MXN $",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "-Cn",
        };
    }
}
exports.EsMxMxn = EsMxMxn;
class EsMxUsd {
    constructor() {
        this.locale = "es-mx";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD $",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "-Cn",
        };
    }
}
exports.EsMxUsd = EsMxUsd;
class EnMxMxp {
    constructor() {
        this.locale = "en-mx";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "MXP",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "-Cn",
        };
    }
}
exports.EnMxMxp = EnMxMxp;
class EnMxMxn {
    constructor() {
        this.locale = "en-mx";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "MXN",
            symbol: "MXN $",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "-Cn",
        };
    }
}
exports.EnMxMxn = EnMxMxn;
class EnMxUsd {
    constructor() {
        this.locale = "en-mx";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM yyyy",
            long: "dddd dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD $",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "-Cn",
        };
    }
}
exports.EnMxUsd = EnMxUsd;
